import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    console.log('apply all connected');
  }

  applyAll(event) {
    console.log('apply all');
    const button = event.currentTarget;
    const userRole = button.dataset.userRole;
    const dropdown = button.closest('.px-1').querySelector('select');
    const selectedValue = dropdown.value; // Get current value of the dropdown

    console.log('Role:', userRole);
    console.log('Value:', selectedValue);

    // Mapping of interchangeable values
    const valueMapping = {
      all: 'yes',
      yes: 'all',
      none: 'no',
      no: 'none',
    };

    const selectClass = `select[name*="[${userRole}]"]`;
    document.querySelectorAll(selectClass).forEach((select) => {
      const effectiveValue = valueMapping[selectedValue] || selectedValue;
      const optionToSet = Array.from(select.options).find(
        (option) => option.value === selectedValue || option.value === effectiveValue
      );
      if (optionToSet && !optionToSet.selected) {
        select.value = optionToSet.value; // Set to the actual value found in the options
        this.flashBorder(select);
        select.dispatchEvent(new Event('change', { bubbles: true })); // Trigger change event if necessary
      }
    });
  }
  flashBorder(element) {
    element.classList.add('flash-border');
    setTimeout(() => {
      element.classList.remove('flash-border');
    }, 2000); // Remove the class after 2000 milliseconds (2 seconds)
  }
}
